"use client"

import { create } from "zustand"

// Store share categoryId giữa CategorySelect và NotificationSelect
// Sử dụng Map để support multiple component instances
interface NotificationCategoryStore {
  categoryMap: Map<string, number | null>
  setCategoryId: (instanceId: string, id: number | null) => void
  getCategoryId: (instanceId: string) => number | null
}

export const useNotificationCategoryStore = create<NotificationCategoryStore>((set, get) => ({
  categoryMap: new Map(),
  setCategoryId: (instanceId, id) => {
    set(state => {
      const newMap = new Map(state.categoryMap)
      newMap.set(instanceId, id)
      return { categoryMap: newMap }
    })
  },
  getCategoryId: instanceId => {
    return get().categoryMap.get(instanceId) || null
  },
}))
